export const BRANCH_COOKIE = 'bigcircle_service_area';
const valid = value => typeof value === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(value);
let memory = '';
export const saveBranchPreference = id => {
  if (!valid(id)) return;
  memory = id;
  try { document.cookie = `${BRANCH_COOKIE}=${encodeURIComponent(id)}; Path=/; Max-Age=31536000; SameSite=Lax${window.location.protocol === 'https:' ? '; Secure' : ''}`; } catch { /* Keep the choice in available storage. */ }
  try { localStorage.setItem('platform-branch', id); } catch { /* Cookie and memory still work without localStorage. */ }
};
export const guestBranchId = () => {
  try { const cookie = document.cookie.split(';').map(value => value.trim()).find(value => value.startsWith(BRANCH_COOKIE + '=')); const value = cookie ? decodeURIComponent(cookie.slice(BRANCH_COOKIE.length + 1)) : ''; if (valid(value)) return value; } catch { /* Ignore malformed or unavailable cookies. */ }
  try { const legacy = localStorage.getItem('platform-branch'); if (valid(legacy)) { saveBranchPreference(legacy); return legacy; } } catch { /* Storage may be unavailable. */ }
  return memory;
};
export const clearBranchPreference = () => {
  memory = '';
  try { document.cookie = `${BRANCH_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax`; } catch { /* Other storage can still be cleared. */ }
  try { localStorage.removeItem('platform-branch'); } catch { /* Cookie is already cleared. */ }
};
